import {
  Component,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef,
  Input,
} from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { StakeholderService } from '@/app/services/stakeholder.service';
import { CommonModule } from '@angular/common';
import { environment } from '@/app/environments/environment';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { GalleryComponent } from '@/app/components/shared/gallery/gallery.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgToastService } from 'ng-angular-popup';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { NgxCurrencyDirective } from 'ngx-currency';
import { ApprovalStatusViewComponent } from '@/app/components/global/approval-status-view/approval-status-view.component';
import { PROJECT_STAGE } from '@/app/enums/project_stages.enum';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrintService } from '@/app/services/shared/print.service';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-project-print-preview',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    GalleryComponent,
    MatDialogModule,
    MatButtonModule,
    ApprovalStatusViewComponent,
    CommonModule,
    NgxCurrencyDirective,
    FormsModule,
    ReactiveFormsModule,
    ApprovalStatusViewComponent,
    MatIconModule,
  ],
  templateUrl: './project-print-preview.component.html',
  styleUrls: ['./project-print-preview.component.css'],
})
export class ProjectPrintPreviewComponent {
  @Input() projectBriefData!: any;
  @Input() projectPlanResponsibilityData!: any;
  @Input() projectPlanRiskRegisterData!: any;
  closeDialog(): void {
    this.dialog.closeAll();
  }

  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  @Output() changeProjectBriefViewMode: EventEmitter<VIEW_MODE> =
    new EventEmitter<VIEW_MODE>();
  selectedImage: any = null;
  selectedImageGroup = 0;
  currentImageIndex = 0;
  selectedMainImage: any = null;
  projectId: any;
  latitude_value: any;
  longitude_value: any;
  mapLink!: SafeResourceUrl;
  uploadedFiles: any[] = [];
  DocumentFiles: any[] = [];
  stakeholders: any[] = [];
  editField: string;
  updatedCountryId: any;
  selectedMileStoneId: any;
  isImagesEdit = false;
  isDocumentsEdit = false;
  nrmItems!: any;
  riskDescriptions$!: Observable<any>;
  country: any;
  total_work_packages = 0;
  total_cost = 0;
  number_of_risks = 0;

  average_risks = 0;
  moderate_risks = 0;
  high_risks = 0;

  currencySymbol: any;

  PROJECT_STAGE = PROJECT_STAGE;

  @Output() changeEdit: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private router: Router,
    private projectsService: ProjectsService,
    private stakeholderService: StakeholderService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private toast: NgToastService,
    private GetProjectIdService: GetProjectIdService,
    private route: ActivatedRoute,
    private getProjectIdService: GetProjectIdService,
    private printService:PrintService,
  ) {}
  projectData: any;
  base_path = environment.storageUrl;
  google_api_key = environment.apiKey;
  revisionId: number;

  gmpCheck = new FormControl(0);

  projectBrief: string;
  projectSiteCondition: string;
  resetRichTextEditor = false;

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  numberToWords(num: any) {
    if (num === 0) return 'zero';

    const belowTwenty = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen',
    ];
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety',
    ];
    const thousands = ['', 'thousand', 'million', 'billion', 'trillion'];

    function helper(n) {
      if (n === 0) return '';
      else if (n < 20) return belowTwenty[n] + ' ';
      else if (n < 100) return tens[Math.floor(n / 10)] + ' ' + helper(n % 10);
      else
        return belowTwenty[Math.floor(n / 100)] + ' hundred ' + helper(n % 100);
    }

    let word = '';
    let index = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[index] + ' ' + word;
      }
      num = Math.floor(num / 1000);
      index++;
    }

    return word.trim();
  }

  print() {
  this.printService.printContent('projectBriefPlanView','project-brief-plan');
  this.closeDialog();
  }

  handleCloseDialog() {
    this.closeDialog();
  }
}
